import React, { Component } from 'react';
import {FormGroup, ControlLabel, FormControl, Button, Modal, Table} from 'react-bootstrap';

import BalanceTable from './BalanceTable'
import TimeOffRow from './TimeOffRow'

class NoteModal extends Component {

  constructor(props) {
    super(props);
    this.state = {note: ''};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({note: e.target.value});
  }

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    let duration = 0;
    const timeoff = nextProps.timeoff;
    if (timeoff) {
      duration = timeoff.days;
      this.setState({
        duration
      })
    }
  }

  render() {
    const {approve, reject, timeoff, show, onClose} = this.props;
    return (

      <Modal
        show={show}
        onHide={onClose}
        aria-labelledby="ModalHeader">

        <Modal.Header closeButton>
          <Modal.Title id="ModalHeader">{`Review the timeoff request from ${timeoff ? timeoff.user.name : ''}`}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Time off request</h4>
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>Type</th>
                <th>Covering</th>
                <th>Start date</th>
                <th>Return date</th>
                <th>Days</th>
                <th>Date requested</th>
              </tr>
            </thead>
            <tbody>
              <TimeOffRow timeoff={timeoff} mini />
            </tbody>
          </Table>

          <h4>Balances on {timeoff && timeoff.startDate}</h4>
          <BalanceTable
            editTimeoffId={timeoff && timeoff.id}
            startDate={timeoff && timeoff.startDate}
            endDate={timeoff && timeoff.endDate}
            type={timeoff && timeoff.type}
            userId={timeoff && timeoff.userId}
            totalDays={timeoff && timeoff.days}
            yearOfBalance={timeoff && timeoff.startDate}
            totalDaysNextYear={timeoff && timeoff.daysNextYear}
          />
          <form>
            <FormGroup
              controlId="formBasicText">

              <ControlLabel>Note:</ControlLabel>

              <FormControl
                type="text"
                value={this.state.note}
                placeholder="Enter the note"
                onChange={this.handleChange} />

              <FormControl.Feedback />

            </FormGroup>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => { approve(this.state.note); this.setState({note: ''}); }}>Approve</Button>
          <Button onClick={() => { reject(this.state.note); this.setState({note: ''}); }}>Reject</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


export default NoteModal;



// WEBPACK FOOTER //
// ./src/components/NoteModal.js